import {AttrsSchema, Component, jsx} from 'panel';

import {IronContextRegistry} from 'common/report/context-registry';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {BannerEl} from 'common/components/banner';
import {BannerAction, BannerSize, BannerTheme, BannerType} from 'common/components/banner/types';
import {CustomAlertsCountResults} from 'app_api/projects/alerts/custom/types';

export class AlertLimitsBanner extends Component<EmptyObj, any, any, any, IronContextRegistry> {
  static get attrsSchema(): AttrsSchema<EmptyObj> {
    return {
      ...super.attrsSchema,
      'project-id': `number`,
    };
  }

  get config() {
    return {
      contexts: [`alertLimits` as const],
      template: () => {
        return !this.isBelowLimit() ? (
          <BannerEl
            sel={`.alert-limit-banner`}
            attrs={{
              theme: BannerTheme.Warn,
              type: BannerType.Embedded,
              size: BannerSize.ExtraSmall,
              'header-text': `Alert cannot be created with anomaly detection criteria`,
              'body-text': `Your organization has reached the limit for active anomaly detection alerts. Delete old anomaly detection alerts to make space for new ones.`,
              ctas: [
                {
                  actionName: BannerAction.Manage,
                  text: `Manage Alerts`,
                  href: `/settings/#account/alert-settings`,
                },
                {
                  actionName: BannerAction.Help,
                  text: `Why do we limit alerts?`,
                  href: `https://docs.mixpanel.com/docs/analysis/advanced/alerts#overview`,
                },
              ],
              'style-override': `.banner-wrapper .banner-panel .banner-copy {margin-bottom: 3px;}`,
              'banner-tracking-type': `Custom Alerts Limit`,
            }}
          />
        ) : null;
      },
    };
  }

  isBelowLimit() {
    const results: CustomAlertsCountResults = this.getContext(`alertLimits`).get().value ?? null;
    return results?.is_below_limit;
  }
}

export const AlertLimitsBannerEl = defineAndMakeJsxFactory<any>(`alert-limits-banner`, AlertLimitsBanner);
